import client from '/src/services/client.js';

export default {
    getUsers : (data) => client.get(`users`,data),
    getUser : (id,data) => client.get(`user/${id}`, data),
    addUser : (data) => client.post(`user`, data),
    updateUser : (id, data) => client.put(`user/${id}`, data),
    deleteUser : (id) => client.delete(`user/${id}`),
    getHistories : (id,data) =>client.get(`user/${id}/logs`,data),
    checkAvaibility : (data) => client.get("user/check-availability", data),
    //getUsersAutocomplete : (name) => client.get(`autocomplete/user/name?term=${name}`)
    getUsersAutocomplete : (name) => client.get(`users?username=${name}`)
}